import { render, staticRenderFns } from "./job_teaser.vue?vue&type=template&id=664b98c0&scoped=true&lang=html&"
import script from "./job_teaser.vue?vue&type=script&lang=js&"
export * from "./job_teaser.vue?vue&type=script&lang=js&"
import style0 from "./job_teaser.vue?vue&type=style&index=0&id=664b98c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../base-image/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664b98c0",
  null
  
)

export default component.exports